export default __webpack_public_path__ + "static/media/Kaiser_avatar.56a8598d.png";